import z from 'zod';

import { ETreatmentPriority } from '@enums/treatment.enum';

import { treatmentSearchSchema } from './treatmentSearch.schema';

export const medicationSearchSchema = treatmentSearchSchema.extend({
  priority: z.enum(ETreatmentPriority).optional().catch(undefined),
});
